import data from "../../../../../packages/react/src/deprecated/FilteredSearch/FilteredSearch.docs.json";
import * as React from 'react';
export default {
  data,
  React
};